export default __webpack_public_path__ + "static/media/Mañanera.b6e35e2a.png";